export const documentationUrls = {
  nl: {
    gettingStartedUrl: 'https://help.reconcept.nl/nl/category/van-start-met-reconcept-14kjg5q/', // DISABLE_TRANSLATION_CHECK
    userManagementUrl: 'https://help.reconcept.nl/nl/category/gebruikersbeheer-1wix2ig/', // DISABLE_TRANSLATION_CHECK
    accessManagementUrl: 'https://help.reconcept.nl/nl/category/toegangsbeheer-en-portfolio-instellingen-qabas6/', // DISABLE_TRANSLATION_CHECK
    faqLoginUrl: 'https://help.reconcept.nl/nl/category/veelgestelde-vragen-xccvvv/', // DISABLE_TRANSLATION_CHECK
  },
  en: {
    gettingStartedUrl: 'https://help.reconcept.nl/en/category/getting-started-12w45ms/', // DISABLE_TRANSLATION_CHECK
    userManagementUrl: 'https://help.reconcept.nl/en/category/user-management-arjtif/', // DISABLE_TRANSLATION_CHECK
    accessManagementUrl: 'https://help.reconcept.nl/en/category/access-management-other-portfolio-settings-547qa1/', // DISABLE_TRANSLATION_CHECK
    faqLoginUrl: 'https://help.reconcept.nl/en/category/faq-1a2yptc/', // DISABLE_TRANSLATION_CHECK
  },
};
